import React from 'react';
import CollegeLogo from '../../CollegeLogo';

/* One event on the rail: date gutter, kind dot, title, subtitle, school logo.

   The date gutter is fixed-width so the dots line up into a spine down the
   list — that alignment is what makes it read as a timeline rather than a
   list of cards. */

export default function RailRow({ event, onOpen }) {
  const dated = event.dateLabel !== '—';
  return (
    <button
      type="button"
      className="rail-row"
      onClick={() => onOpen(event)}
      data-testid={`rail_row_${event.id}`}
      aria-label={dated ? `${event.title}, ${event.dateLabel}` : `${event.title}, no date`}
    >
      <span className="rail-row__date">{event.dateLabel}</span>
      <span className={`rail-row__dot rail-row__dot--${event.kind}`} aria-hidden="true" />
      <span className="rail-row__body">
        <span className="rail-row__title">{event.title}</span>
        <span className="rail-row__sub">{event.subtitle}</span>
      </span>
      <span className="rail-row__logo">
        <CollegeLogo
          schoolName={event.schoolName}
          logoUrl={event.logoUrl}
          unitid={event.unitid}
          size={32}
        />
      </span>
    </button>
  );
}
